import { render, staticRenderFns } from "./lifeFinance.vue?vue&type=template&id=cbdfe972&scoped=true"
import script from "./lifeFinance.vue?vue&type=script&lang=js"
export * from "./lifeFinance.vue?vue&type=script&lang=js"
import style0 from "./lifeFinance.vue?vue&type=style&index=0&id=cbdfe972&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbdfe972",
  null
  
)

export default component.exports